import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import { ALIAS_MIN_LENGTH, ALIAS_MAX_LENGTH } from '../../services/appConstants/appConstants.js';
import Input from '../../components/Input/Input.js';
import Icon from '../../components/Icon/Icon.js';
import { isValidLikeMGW } from '../../services/utilities/validation.js';
import styles from './Alias.module.scss.js';

function Alias(_ref) {
  var alias = _ref.alias,
    onClick = _ref.onClick,
    onAliasValidated = _ref.onAliasValidated,
    onAliasUpdated = _ref.onAliasUpdated,
    saveError = _ref.saveError,
    dataTestId = _ref.dataTestId;
  var aliasError = !(alias !== null && alias !== void 0 && alias.trim()) || !isValidLikeMGW(alias);
  var aliasErrorMsg = function aliasErrorMsg() {
    if (!alias) {
      return t('MPLIB_SYSTEM_SETTINGS_ALIAS_CAN_NOT_BE_EMPTY');
    }
    if (aliasError) {
      return t('MPLIB_SYSTEM_SETTINGS_INVALID_ALIAS');
    }
    if (saveError) {
      return saveError;
    }
    return '';
  };
  useEffect(function () {
    onAliasValidated(!aliasError);
  }, [alias]);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: styles.topRow
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, t('MPLIB_SYSTEM_SETTINGS_INSTALLATION_ADDRESS_ALIAS_TITLE')), /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-info",
    onClick: onClick
  })), /*#__PURE__*/React.createElement(Input, {
    onChange: onAliasUpdated,
    maxLength: ALIAS_MAX_LENGTH,
    minLength: ALIAS_MIN_LENGTH,
    placeholder: t('MPLIB_SYSTEM_SETTINGS_INSTALLATION_ADDRESS_ALIAS_PLACE_HOLDER'),
    value: alias,
    dataTestId: dataTestId,
    hasError: Boolean(aliasError),
    errorMessage: aliasErrorMsg(),
    mandatory: true,
    className: styles.nobottom
  }));
}
Alias.propTypes = {
  alias: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onAliasValidated: PropTypes.func,
  onAliasUpdated: PropTypes.func,
  saveError: PropTypes.string,
  dataTestId: PropTypes.string
};
Alias.defaultProps = {
  alias: null,
  onAliasValidated: function onAliasValidated() {},
  onAliasUpdated: function onAliasUpdated() {},
  saveError: '',
  dataTestId: ''
};

export { Alias as default };
